import { makeObservable } from 'mobx'
import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import type { FirebaseRepository } from './FirebaseRepository'
import type { FirestoreSlideCaption } from '../firestore/SlideCaption'
import { empty } from '../firestore/SlideCaption'

export class SlideCaption extends ObservableModelWithDecorators<FirestoreSlideCaption> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreSlideCaption>
  ) {
    super(repository, doc)

    makeObservable(this)
  }
}
